import { fetchWithAuth } from "../utils/authFetch";

const cache = {};
const fetching = {};
const JOB_DETAIL_CACHE_TTL_MS = 5 * 60 * 1000;

export function getCachedJobDetail(jobId) {
  if (!jobId) return null;
  const key = String(jobId);
  const entry = cache[key];
  if (!entry) return null;
  const isFresh = Date.now() - entry.cachedAt <= JOB_DETAIL_CACHE_TTL_MS;
  return isFresh ? entry.data : null;
}

export function primeJobDetailCache(job) {
  const jobId = job?._id?.$oid || job?._id;
  if (!jobId || !job) return;
  const key = String(jobId);
  cache[key] = { data: job, cachedAt: Date.now() };
}

export async function getJobDetail(jobId, { forceRefresh = false } = {}) {
  if (!jobId) throw new Error("getJobDetail: jobId is required");
  const key = String(jobId);

  if (!forceRefresh) {
    const cached = getCachedJobDetail(key);
    if (cached) return cached;
  }

  if (fetching[key]) return fetching[key];

  const p = (async () => {
    const res = await fetchWithAuth(`/api/jobs/${encodeURIComponent(key)}`);
    if (!res.ok) {
      throw new Error(`Job not found (${res.status})`);
    }
    const json = await res.json();
    cache[key] = { data: json, cachedAt: Date.now() };
    return json;
  })();

  fetching[key] = p;
  try {
    return await p;
  } finally {
    delete fetching[key];
  }
}
